// extracted by mini-css-extract-plugin
export default {"chatInput":"ChatInput_chatInput__V9L4B","box":"ChatInput_box__F7OIf"};